var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hp-manager-page-list"},[_c('standard-table',{ref:"datas",attrs:{"size":"default","bordered":true,"columns":_vm.columns,"indentSize":15,"dataSource":_vm.datas,"pagination":_vm.pagination,"loading":_vm.loading},on:{"tableChange":_vm.tableChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd1c14e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/Goods/BomProduct/PackageList.vue
// module id = null
// module chunks = 